import { message } from 'antd';
import { AxiosInstance } from 'axios';
import { Dayjs } from 'dayjs';

import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Reception } from '@/model/Logistic/Reception/Reception';

import ReceptionApi from './ReceptionApi';

class ReceptionRepository {
  receptionApi: ReceptionApi;

  constructor(axiosInstance: AxiosInstance) {
    this.receptionApi = new ReceptionApi(axiosInstance);
  }

  updateReceptionState = async (
    receptionsId: number | number[],
    newState: PACKAGE_STATES,
    date?: Dayjs,
  ) => {
    try {
      if (Array.isArray(receptionsId)) {
        const response = await Promise.all(
          receptionsId.map(receptionId =>
            this.receptionApi.updateReceptionState(receptionId, newState, date),
          ),
        );

        message.success('Estado de las recepciones actualizado correctamente');

        return response.map(res => res.data);
      } else {
        const response = await this.receptionApi.updateReceptionState(receptionsId, newState, date);

        message.success('Estado de la recepción actualizado correctamente');

        return response.data;
      }
    } catch (error) {
      console.error('Error updating reception state:', error);
      message.error('Error al actualizar el estado de la recepción');
      throw error;
    }
  };

  updateReceptionShipper = async (receptionId: number, shipperId: number) => {
    try {
      const response = await this.receptionApi.updateReceptionShipper(receptionId, shipperId);

      message.success('Operador logístico actualizado correctamente');

      return response.data;
    } catch (error) {
      message.error('Error al actualizar el operador logístico');
      throw error;
    }
  };
  updateReceptionTechnician = async (receptionId: number, technicianId?: number) => {
    try {
      const response = await this.receptionApi.updateReceptionTechnician(receptionId, technicianId);

      message.success('Técnico actualizado correctamente');

      return response.data;
    } catch (error) {
      message.error('Error al actualizar el técnico');
      throw error;
    }
  };
  updateReception = async (receptionId: number, receptionData: Partial<Reception>) => {
    try {
      const response = await this.receptionApi.updateReception(receptionId, receptionData);

      message.success('Recepción actualizada correctamente');

      return response;
    } catch (error) {
      message.error('Error al actualizar la recepción');
      throw error;
    }
  };

  sendClaimEmail = async (receptionId: number, emails: string) => {
    try {
      const response = await this.receptionApi.sendClaimEmail(receptionId, emails);

      return response;
    } catch (error) {
      message.error('Error al enviar el mensaje');
      throw error;
    }
  };
}

export default ReceptionRepository;
